import { makeQueryOptions } from '@mint-lib/api-zod-support/react-query';

import { defaultApi, defaultClient } from '@mint-sdk/api-core';
import { z } from 'zod';

import {
  integrationsResponseSchema,
  selectGoogleAnalyticsIntegrationRequestDeprecatedSchema,
  selectGoogleAnalyticsIntegrationRequestSchema,
} from '../shared/schemas/integrations.js';
import { UTMConfigsResponseSchema } from '../shared/schemas/utm.js';

export const getIntegrations = defaultApi.declareEndpoint({
  url: `ga4-service/integrations/?add_is_refresh_token_valid_flag=true` as const,
  method: 'GET',
  responseSchema: integrationsResponseSchema,
});

export const selectGoogleAnalyticsIntegration = defaultApi.declareEndpoint({
  url: `ga4-service/v3/utm-configs/` as const,
  method: 'POST',
  responseSchema: UTMConfigsResponseSchema,
  requestSchema: selectGoogleAnalyticsIntegrationRequestSchema,
});

export const selectGoogleAnalyticsIntegrationDeprecated =
  defaultApi.declareEndpoint({
    url: `ga4-service/utm-configs/` as const,
    method: 'POST',
    responseSchema: z.object({}),
    requestSchema: selectGoogleAnalyticsIntegrationRequestDeprecatedSchema,
  });

export const getIntegrationsQueryOptionsDeprecated = makeQueryOptions(
  getIntegrations,
  {
    processResponse(data) {
      return data;
    },
  },
);

export const getIntegrationsQueryOptions = defaultClient.query({
  url: `ga4-service/integrations/?add_is_refresh_token_valid_flag=true` as const,
  method: 'GET',
  responseSchema: integrationsResponseSchema,
  processResponse(data) {
    return data;
  },
});
